import helper from '@/mixins/helpers'
const nordeaInvoiceExportReport = (headers, payload, translations, fromMain) => {
  let getHeaders = ''
  let getContent = ''
  headers = payload.invoiceitems && payload.invoiceitems.some(x => x.discount) ? headers : headers.filter(x => x.value !== 'discount')
  var hasDiscount = headers.find(x => x.value === 'discount')
  for (let i = 0; i < headers.length; i++) {
    if (!hasDiscount && (headers[i].value === 'description')) {
      getHeaders += `<th class="th-fontsize" width="48%">${headers[i].text}</th>`
    } else if (headers[i].value === 'qty' || headers[i].value === 'base_price' || headers[i].value === 'discount' || headers[i].value === 'sum_ex_vat') getHeaders += `<th class="th-fontsize text-right" width="${headers[i].reportWidth}">${headers[i].text}</th>`
    else getHeaders += `<th class="th-fontsize" width="${headers[i].reportWidth}">${headers[i].text}</th>`
  }
  let mva = 0
  let totalSum = 0
  for (let j = 0; j < payload.invoiceitems.length; j++) {
    // calculate the mva here!
    mva += helper.methods.getRoundedNumberWithPrecision((((payload.invoiceitems[j].sum_ex_vat || 0) * (payload.invoiceitems[j].vat || 0)) / 100))
    totalSum += payload.invoiceitems[j].sum_ex_vat ? helper.methods.getRoundedNumberWithPrecision(payload.invoiceitems[j].sum_ex_vat) : 0
    getContent += '<tr>'
    for (let i = 0; i < headers.length; i++) {
      if (headers[i].value === 'qty') {
        getContent += `<td class="th-fontsize text-right" style="border-top:none;">
          ${!payload.invoiceitems[j].isinformation ? helper.methods.$_replaceDotWithCommaIfHasDecimal(payload.invoiceitems[j][headers[i].value] || 0) : ''}
        </td>`
      } else if (headers[i].value === 'base_price' || headers[i].value === 'sum_ex_vat') {
        getContent += `<td class="th-fontsize text-right" style="border-top:none;">
          ${!payload.invoiceitems[j].isinformation ? helper.methods.$_thousandSeparator(payload.invoiceitems[j][headers[i].value] || 0) : ''}
        </td>`
      } else if (headers[i].value === 'discount') {
        getContent += payload.invoiceitems && payload.invoiceitems.some(x => x.discount) ? `<td class="th-fontsize text-right" style="border-top:none;">
          ${!payload.invoiceitems[j].isinformation ? helper.methods.$_thousandSeparator(payload.invoiceitems[j][headers[i].value] || 0) : ''}
        </td>` : ''
      } else getContent += `<td class="th-fontsize" style="border-top:none;">${payload.invoiceitems[j][headers[i].value] || ''}</td>`
    }
    getContent += '</tr>'
    if (payload.invoiceitems[j].comments) getContent += `<tr><td style="border-top:none;"></td><td colspan="5" style="border-top:none;">${payload.invoiceitems[j].comments || ''}</td></tr>`
  }
  var defaultText = 'Det er inngått factoringavtale med Nordea Finance Equipment AS (NFE). Denne og fremtidige fakturaer, ekskl. kreditnotaer er pantsatt til NFE. Befriende betaling kan kun skje til: Nordea Finance Equipment AS, PB 105, 1325 Lysaker'
  var settings = payload.invoice.commonsettingdata ? { ...JSON.parse(payload.invoice.commonsettingdata || {}) } : {}
  settings.Financial_Institution_Branch = ''
  settings.Financial_Payment_Identifier = ''
  settings.Financial_Payment_Identifier_International = ''
  if (payload.invoice.paymentmethod1 === 'sg' || payload.invoice.paymentmethod1 === 'SG') {
    settings.Financial_Institution_Branch = settings.SG_Financial_Institution_Branch
    settings.Financial_Payment_Identifier = settings.SG_Financial_Payment_Identifier
    settings.Financial_Payment_Identifier_International = settings.SG_Financial_Payment_Identifier_International
  } else if (payload.invoice.paymentmethod1 === 'direct' || payload.invoice.paymentmethod1 === 'direkte' ||
            payload.invoice.paymentmethod1 === 'Direct' || payload.invoice.paymentmethod1 === 'Direkte') {
    settings.Financial_Institution_Branch = settings.Direct_Financial_Institution_Branch
    settings.Financial_Payment_Identifier = settings.Direct_Financial_Payment_Identifier
    settings.Financial_Payment_Identifier_International = settings.Direct_Financial_Payment_Identifier_International
    defaultText = ''// if direct payment is used then make it empty
  }
  const invoiceObj = {
    customer: payload.invoice.customerdata ? JSON.parse(payload.invoice.customerdata || {}) : {},
    deliveryaddress: payload.invoice.customeraddressdata ? JSON.parse(payload.invoice.customeraddressdata || {}) : {},
    ordercustomer: payload.invoice.ordercustomerdata ? JSON.parse(payload.invoice.ordercustomerdata || {}) : {},
    invoiceaddress: payload.invoice.invoiceaddressdata ? JSON.parse(payload.invoice.invoiceaddressdata || {}) : {},
    order: payload.invoice.orderdata ? JSON.parse(payload.invoice.orderdata || {}) : {},
    invoice: payload.invoice,
    kidnumber: payload.invoice.kidnumber,
    ourreference: payload.invoice.ourreferencedata ? JSON.parse(payload.invoice.ourreferencedata || {}) : {},
    currency: payload.invoice.currencydata ? JSON.parse(payload.invoice.currencydata || {}) : {}
  }

  let grandTotal = helper.methods.getRoundedNumberWithPrecision(totalSum + mva)
  let roundOffValue = helper.methods.getRoundedNumberWithPrecision(grandTotal, 0) - grandTotal
  const totalCalculatedValue = {
    mva,
    grandTotal,
    roundingValue: roundOffValue,
    totalSum
  }
  return content(getHeaders, getContent, invoiceObj, settings, defaultText, translations, fromMain, totalCalculatedValue)
}

const content = (headers, content, { customer, deliveryaddress, ordercustomer, invoiceaddress, order, invoice, kidnumber, ourreference, currency }, settings, defaultText, trans, fromMain, totalCalculatedValue) => `
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-6 noso_info">
          <img class="img-responsive" height="180" width="180" src="https://kilabapi.apphouse.no/kilab_logo.png">
          <div class="row">
            <div class="col-xs-12">
                <span>Kilab AS, Orgnr 912195759</span><br>
                <span>Majorvegen 22, 2030 Nannestad</span><br>
                <span>firmapost@kilab.no &nbsp &nbsp &nbsp www.kilab.no</span><br><br>
            </div>
            <div class="col-xs-12" style="padding-top:10px;">
              <span>${customer ? customer.Name || '' : ''}</span><br>
              <span>${invoiceaddress ? invoiceaddress.Address || '' : ''}</span><br>
              ${invoiceaddress.Address2 ? `<span>${invoiceaddress.Address2 || ''}</span><br>` : ''}
              <span>${invoiceaddress ? invoiceaddress.PostCode || '' : ''} ${invoiceaddress ? invoiceaddress.City || '' : ''}</span><br>
              <span>${invoiceaddress ? invoiceaddress.CountryName || '' : ''}</span>
            </div>
            <div class="col-xs-12" style="padding-top:20px;">
              <span>${trans.deliveryAddress || 'Delivery address'}:</span><br>
              <span>${ordercustomer ? ordercustomer.Name || '' : ''}</span><br>
              <span>${deliveryaddress ? deliveryaddress.Address || '' : ''}</span><br>
              ${deliveryaddress.Address2 ? `<span>${deliveryaddress.Address2 || ''}</span><br>` : ''}
              <span>${deliveryaddress ? deliveryaddress.PostCode || '' : ''} ${deliveryaddress ? deliveryaddress.City || '' : ''}</span><br>
              <span>${deliveryaddress ? deliveryaddress.CountryName || '' : ''}</span>
            </div>
          </div>
        </div>
        <div class="col-xs-6">

          <div class="row">
            <div class="col-xs-6">
              <h3><b>${invoice && invoice.type ? getInvoiceCreatedType(invoice.type, trans) : ''}</b></h3>
            </div>
            <div class="col-xs-6 text-right">
              <h3><b>${fromMain ? (invoice.number || '') : '{{invoice_number}}'}</b></h3>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.orderNo || 'Order no'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${order ? order.Number || '' : ''}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.customerNo || 'Order no'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${customer ? customer.Custom_Number || '' : ''}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.invoiceDate || 'Invoice date'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${invoice && invoice.invoice_date ? helper.methods.$_filterDate(invoice.invoice_date) : '&nbsp;'}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.payDeadline || 'Payment deadline'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${invoice && invoice.due_date ? helper.methods.$_filterDate(invoice.due_date) : '&nbsp;'}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.kid || 'Kid'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${kidnumber ? kidnumber : '{{kid_number}}'}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.amountPay || 'Amount to pay'} (${currency && currency.Name ? currency.Name : 'NOK'}):</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${totalCalculatedValue ? helper.methods.$_thousandSeparator(totalCalculatedValue.grandTotal || 0, 0) : ''} </h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.accNumber || 'Account number'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${settings ? settings.Financial_Payment_Identifier || '' : ''}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.saleRef || 'Sales ref'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${order ? order.SalesReference || '&nbsp;' : '&nbsp;'}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.ourReference || 'Our ref'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${ourreference ? ourreference.FirstName || '' : ''} ${ourreference ? ourreference.LastName || '' : ''}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.yourReference || 'Your ref'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${invoice ? invoice.your_reference || '' : ''}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.yourOrderNumber || 'Your ref'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${order ? order.YourOrderNumber || '' : ''}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.yourContactPerson || 'Your ref'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${invoice ? invoice.your_contact || '' : ''}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.labeled || 'Labeled'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments"> ${order ? order.Labeled || '&nbsp;' : '&nbsp;'} </h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.orderDate || 'Order date'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${order && order.OrderDate ? helper.methods.$_formatDate(order.OrderDate, 'YYYY-MM-DD', 'DD.MM.YYYY') : '&nbsp;'}</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <h4 class="margin-adjustments">${trans.paymentTerms || 'P. terms'}:</h4>
            </div>
            <div class="col-xs-6 text-right">
              <h4 class="margin-adjustments">${invoice ? invoice.payment_term || '0' : '0'} dager</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="padding-top:10px;">
        <table class="table table-invoice-items" width="100">
          <thead>
            <tr class="border">
              ${headers}
            </tr>
          </thead>
          <tbody>
            ${content}
          </tbody>
        </table>
      </div>
      <div class="row">
        <div class="col-xs-6">
          ${defaultText}
        </div>
        <div class="col-xs-6 text-right">
          <div class="row">
            <div class="col-xs-8">
              <b>${trans.totalExVat || 'Total Ex VAT'}:</b>
            </div>
            <div class="col-xs-4 noso_info">
            ${totalCalculatedValue ? helper.methods.$_thousandSeparator(totalCalculatedValue.totalSum || 0) : ''}
            </div>
          </div>
          <div class="row">
            <div class="col-xs-8">
              <b>${trans.vat || 'VAT'}:</b>
            </div>
            <div class="col-xs-4 noso_info">
            ${totalCalculatedValue ? helper.methods.$_thousandSeparator(totalCalculatedValue.mva || 0) : ''}
            </div>
          </div>
          <div class="row">
            <div class="col-xs-8">
              <b>${trans.roundOff || 'Round off'}:</b>
            </div>
            <div class="col-xs-4 noso_info">
            ${totalCalculatedValue ? helper.methods.$_thousandSeparator(totalCalculatedValue.roundingValue || 0) : ''}
            </div>
          </div>
          <div class="row">
            <div class="col-xs-8">
              <b>${trans.totalIncVat || 'Total incl. vat'}:</b>
            </div>
            <div class="col-xs-4 noso_info">
              ${totalCalculatedValue ? helper.methods.$_thousandSeparator(totalCalculatedValue.grandTotal || 0, 0) : ''}
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        ${invoice && invoice.tasks_performed ? `<div class="col-xs-11"><br /><p><b>${trans.comments || 'Kommentarer'}:</b></p>${invoice.tasks_performed}</div>` : ''}
      </div>
    </div>
  `
const getInvoiceCreatedType = (type, trans) => {
  const types = [{
    text: trans.invoice || 'Invoice',
    value: 1
  }, {
    text: trans.creditNote || 'Credit note',
    value: 2
  }]
  const getType = types.find(x => x.value === type)
  if (getType) return getType.text
  else return ''
}
export default nordeaInvoiceExportReport
